export var Edge;
(function (Edge) {
    Edge[Edge["Bottom"] = 0] = "Bottom";
    Edge[Edge["Left"] = 1] = "Left";
    Edge[Edge["Right"] = 2] = "Right";
    Edge[Edge["Top"] = 3] = "Top";
})(Edge || (Edge = {}));
export var Align;
(function (Align) {
    Align[Align["Start"] = 0] = "Start";
    Align[Align["End"] = 1] = "End";
})(Align || (Align = {}));
export function getRelativePosition(relativeTo, edge, align) {
    var rect = transformRect(relativeTo);
    var result = {};
    switch (edge) {
        case Edge.Left:
            result.right = rect.right;
            break;
        case Edge.Right:
            result.left = rect.left + rect.width;
            break;
        case Edge.Top:
            result.bottom = rect.bottom + rect.height;
            break;
        default:
            result.top = rect.top + rect.height;
    }
    switch (edge) {
        case Edge.Left:
        case Edge.Right:
            if (align === Align.End) {
                result.bottom = rect.bottom;
            }
            else {
                result.top = rect.top;
            }
            break;
        default:
            if (align === Align.End) {
                result.right = rect.right;
            }
            else {
                result.left = rect.left;
            }
            break;
    }
    return result;
}
function transformRect(rect) {
    var top = rect.top + (window.scrollY || window.pageYOffset);
    var left = rect.left + (window.scrollX || window.pageXOffset);
    return {
        top: top,
        left: left,
        right: window.innerWidth - (left + rect.width),
        bottom: window.innerHeight - (top + rect.height),
        width: rect.width,
        height: rect.height,
    };
}
//# sourceMappingURL=getRelativePosition.js.map